import { render, staticRenderFns } from "./OrderViewActionSendInvoice.vue?vue&type=template&id=3a952edc&scoped=true&"
import script from "./OrderViewActionSendInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionSendInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActionSendInvoice.vue?vue&type=style&index=0&id=3a952edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a952edc",
  null
  
)

export default component.exports